import { useEffect } from "react";

const SITE = "https://vedic-destiny-hub-2.preview.emergentagent.com";
const DEFAULT_IMAGE = `${SITE}/assets/og-image.jpg`;
const DEFAULT_DESC = "YourAstroHub — Premium Vedic astrology consultations, live and recorded Jyotish courses, and remedies rooted in 10+ years of classical practice by mentor Bhupaal Bisht.";

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function injectJsonLd(id, obj) {
  if (!obj) return;
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.id = id;
  s.textContent = JSON.stringify(obj);
  document.head.appendChild(s);
}

/**
 * Reusable SEO helper. Updates title, description, keywords, canonical, OG, Twitter cards,
 * BreadcrumbList schema, and any additional JSON-LD schemas passed in.
 */
export default function Seo({
  title,
  description = DEFAULT_DESC,
  keywords,
  path = "/",
  image = DEFAULT_IMAGE,
  breadcrumbs, // [{ name, path }]
  schemas = [], // extra JSON-LD objects
}) {
  useEffect(() => {
    const canonical = `${SITE}${path}`;
    document.title = title || "YourAstroHub — Decode Your Destiny with Vedic Wisdom";
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertLink("canonical", canonical);
    upsertMeta("property", "og:title", title || "YourAstroHub");
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:site_name", "YourAstroHub");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title || "YourAstroHub");
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    // Breadcrumbs schema
    if (breadcrumbs && breadcrumbs.length) {
      injectJsonLd("seo-breadcrumbs", {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${SITE}${b.path}`,
        })),
      });
    } else {
      const el = document.getElementById("seo-breadcrumbs");
      if (el) el.remove();
    }

    // Extra schemas (FAQ, Course, etc.)
    // Clean up previous ones
    document.querySelectorAll('script[id^="seo-extra-"]').forEach((n) => n.remove());
    schemas.forEach((s, i) => injectJsonLd(`seo-extra-${i}`, s));

    return () => {
      // On unmount, don't strip everything (SPA — next page's <Seo> will overwrite)
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, keywords, path, image, JSON.stringify(breadcrumbs), JSON.stringify(schemas)]);

  return null;
}
